import React from "react";

const IMG = `${import.meta.env.BASE_URL}img/roulette`;

/**
 * Reference result body for the roulettes (ourroullete / roulette11 / roulette12 / roulette13):
 *   .row.row5.worli-result > .col-12.col-lg-7 > … .casino-result-cards-item > img({card}.png)
 */
export default function RouletteResultBody({ t1 }) {
  const card = String(t1?.card ?? "").trim();
  return (
    <div className="row row5 worli-result">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center w-100">
            <div className="casino-result-cards">
              {card ? (
                <div className="casino-result-cards-item">
                  <img src={`${IMG}/${card}.png`} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
